module.exports = __webpack_public_path__ + "static/media/Laugo_22.47b6df97.jpg";